export const LIST = "list";
export const FIND = "find";
export const CREATE = "create";
export const UPDATE = "update";
export const DELETE = "delete";
export const REVERT = "revert";
export const IMPORT = "import";
